import { Button, Kind } from '@thanx/uikit/button'
import { Modal } from '@thanx/uikit/modal'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { Translate } from 'react-redux-i18n'
import { merchantTheme } from 'theme'

const t = buildTranslate('components.legal_docs_block_modal')

type Props = {
  isOpen: boolean
  onContinue: () => void
}

const LegalDocsBlockModal: React.FC<Props> = ({ isOpen, onContinue }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      closeable={false}
      zIndex={merchantTheme.zIndex.modal}
    >
      <div className="p-xl">
        <Text.Header3 tag="div" color="grey90" className="mb-s">
          {t('title')}
        </Text.Header3>
        <Text.BodyText3 tag="div" color="grey70" className="mb-l">
          <Translate
            value="components.legal_docs_block_modal.description"
            dangerousHTML
          />
        </Text.BodyText3>
        <div className="d-flex justify-content-end">
          <Button kind={Kind.PRIMARY} onClick={onContinue}>
            {t('continue')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default LegalDocsBlockModal
